import React, { Component } from 'react';

import { FarvetLinkOgIkonBokseProps, FarvetLinkOgIkonBokseState } from './farvetLinkOgIkonBokse.definition';

let animationStartTid = 0;
const animationFart = 0.2;

export class FarvetLinkOgIkonBokse extends Component<FarvetLinkOgIkonBokseProps, FarvetLinkOgIkonBokseState> {
	constructor(props: any) {
		super(props);
		this.state = {
			currentId: '',
			currentKolonne: null
		};
	}

	classes = (icon) => {
		const classes = `icon ${icon}`;
		return classes;
	};

	generateKey = (pre) => {
		return `${pre}_${new Date().getTime()}`;
	};

	hent2kolonner = (startIndex, nuance) => {
		return this.props.kolonner.slice(startIndex, startIndex + 2).map((content, index) => {
			animationStartTid = animationStartTid + animationFart;
			const animationStyle = this.props.visAnimation ? { backgroundColor: nuance[index + startIndex], animation: 'fade-in-fwd 0.1s cubic-bezier(0.390, 0.575, 0.565, 1.000) both', animationDelay: animationStartTid - animationFart + 's' } : { backgroundColor: nuance[index + startIndex] };
			return (
				<a href = { content.linkUrl } style = { { 'textDecoration': 'none' } } key = { 'twoColumns_' + (index + startIndex) + this.generateKey(content) } >
					<div className="item columns medium-6 twoColumns" style={ animationStyle }>
						<div className="hovedSideEnkeltKolonne text-center">
							<div className={ this.classes(content.ikon) } style={ { 'color': 'white' } }>
								<span className="path1" />
								<span className="path2" />
								<span className="path3" />
								<span className="path4" />
								<span className="path5" />
								<span className="path6" />
								<span className="path7" />
								<span className="path8" />
								<span className="path9" />
								<span className="path10" />
								<span className="path11" />
								<span className="path12" />
							</div>
							<h4>{ content.overskrift && content.overskrift }</h4>
							<p dangerouslySetInnerHTML={ { __html: content.beskrivelse } } />
							<span className="icon-link-arrow-new" />
						</div>
					</div>
				</a>
			);
		}
		);
	};

	hent3kolonner = (startIndex, nuance) => {
		return this.props.kolonner.slice(startIndex, startIndex + 3).map((content, index) => {
			animationStartTid = animationStartTid + animationFart;
			const animationStyle = this.props.visAnimation ? { backgroundColor: nuance[index + startIndex], animation: 'fade-in-fwd 0.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both', animationDelay: animationStartTid - animationFart + 's' } : { backgroundColor: nuance[index + startIndex] };

			return (
				<a href={ content.linkUrl } style={ { 'textDecoration': 'none' } } key={ 'threeColumns_' + (index + startIndex) + this.generateKey(content) }>
					<div className="item columns medium-4 threeColumns" style={ animationStyle }>
						<div className="hovedSideEnkeltKolonne text-center">
							<div className={ this.classes(content.ikon) } style={ { 'color': 'white' } }>
								<span className="path1" />
								<span className="path2" />
								<span className="path3" />
								<span className="path4" />
								<span className="path5" />
								<span className="path6" />
								<span className="path7" />
								<span className="path8" />
								<span className="path9" />
								<span className="path10" />
								<span className="path11" />
								<span className="path12" />
							</div>
							<h4>{ content.overskrift && content.overskrift }</h4>
							<p dangerouslySetInnerHTML={ { __html: content.beskrivelse } } />
							<span className="icon-link-arrow-new" />
						</div>
					</div>
				</a>
			);
		}
		);
	};

	hent4kolonner = (startIndex, nuance) => {
		return this.props.kolonner.slice(startIndex, startIndex + 4).map((content, index) => {
			animationStartTid = animationStartTid + animationFart;
			const animationStyle = this.props.visAnimation ? { backgroundColor: nuance[index + startIndex], animation: 'fade-in-fwd 0.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both', animationDelay: animationStartTid - animationFart + 's' } : { backgroundColor: nuance[index + startIndex] };

			return (
				<a href={ content.linkUrl } style={ { 'textDecoration': 'none' } } key={ 'fourColumns_' + (index + startIndex) + this.generateKey(content) }>
					<div className="item columns medium-3 fourColumns" style={ animationStyle }>
						<div className="hovedSideEnkeltKolonne text-center">
							<div className={ this.classes(content.ikon) } style={ { 'color': 'white' } }>
								<span className="path1" />
								<span className="path2" />
								<span className="path3" />
								<span className="path4" />
								<span className="path5" />
								<span className="path6" />
								<span className="path7" />
								<span className="path8" />
								<span className="path9" />
								<span className="path10" />
								<span className="path11" />
								<span className="path12" />
							</div>
							<h4>{ content.overskrift && content.overskrift }</h4>
							<p dangerouslySetInnerHTML={ { __html: content.beskrivelse } } />
							<span className="icon-link-arrow-new" />
						</div>
					</div>
				</a>
			);
		}
		);
	};

	render() {
		let kolonner = null;
		const groenNuance = ['#008DB5', '#076364', '#10A2A3', '#2A2C5E', '#2F4E76', '#2A5875', '#1E363A', '#3586B4'];
		const lillaNuance = ['#5B1F59', '#C776B0', '#93217C', '#916EAA', '#2F4E76', '#2A5875', '#1E363A', '#3586B4'];
		const nuance = this.props.farveNuance == 'green' ? groenNuance : lillaNuance;
		animationStartTid = 0;

		switch (this.props.kolonner.length) {
		case 2:
			kolonner = this.hent2kolonner(0, nuance);
			break;
		case 3:
			kolonner = this.hent3kolonner(0, nuance);
			break;
		case 4:
			kolonner = this.hent4kolonner(0, nuance);
			break;
		case 5:
			kolonner = this.hent2kolonner(0, nuance);
			kolonner = kolonner.concat(this.hent3kolonner(2, nuance));
			break;
		case 6:
			kolonner = this.hent3kolonner(0, nuance);
			kolonner = kolonner.concat(this.hent3kolonner(3, nuance));
			break;
		case 7:
			kolonner = this.hent3kolonner(0, nuance);
			kolonner = kolonner.concat(this.hent4kolonner(3, nuance));
			break;
		case 8:
			kolonner = this.hent4kolonner(0, nuance);
			kolonner = kolonner.concat(this.hent4kolonner(4, nuance));
			break;

		default:
			console.info(this.props.kolonner.length + ' rækker, understøttes ikke af denne komponent.');
			break;
		}

		return (
			<div>
				<div className="kolonner base-band">
					<div className="row">
						{ kolonner }
					</div>
				</div>
			</div>
		);
	}
}

export default FarvetLinkOgIkonBokse;